<template>
  <a class="skip-main" href="#main-content">Skip to main content</a>
</template>

<style lang="postcss" scoped>
a.skip-main {
  left: -999px;
  position: absolute;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
  z-index: -999;
}

a.skip-main:focus,
a.skip-main:active {
  color: var(--white);
  background-color: var(--black);
  left: auto;
  top: auto;
  width: 30%;
  height: auto;
  overflow: auto;
  margin: var(--space-8) 35%;
  padding: var(--space-4);
  border-radius: var(--space-16);
  border: var(--space-4) solid var(--blue);
  text-align: center;
  font-size: var(--font-size-18);
  z-index: 999;
}
</style>
